import Moment from 'react-moment';
import _ from 'lodash';
import {connect} from "react-redux";
import React, {Fragment,Component} from 'react';
import ViewHeader from '../view-header';
import ReactTooltip from 'react-tooltip';
import ModalComponent from '../../../../components/Modal';
import Notice from '../../../../components/Notification/newNotification';
import Table from '../../../../components/Table/index';
import CustomModalBody from '../../../../components/Patient/CustomModalBody';
import { Row } from 'reactstrap';
import {
    addPatient,
    deletePatient,
    editPatient,
    getPatient,
    addPickup,
    getParentCases,
    addBooking
} from "../Home/actions";
import {getCase} from "../CaseDetails/actions";
import '../../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Spinner from '../../../../components/Spinner';

//Icons
import IconEdit from 'react-icons/lib/fa/edit';
import IconTrash from 'react-icons/lib/fa/trash-o';
import History from "../../../../components/History";
import PatientsTable from "../PatientsTable";
import {
    ADD_CASE_SUCCESS_MESSAGE,
    CANCEL_PICKUP_CASE_SUCCESS_MESSAGE,
    SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE
} from "../../../../shared/constants";
import SubcaseModalBody from "../../../../components/CreateSubcase";
import SubcaseForm from "../../../../components/SubCaseForm";

class Cases extends Component {
    constructor (props) {
        super(props);
        this.state = {
            tableOption: {
                noDataText: 'No patient is available yet.',
                hideSizePerPage: true,
                sizePerPage: 10,
                onRowClick: (row) => this.linkToCasesPage(row),
            },
            selectRowProp: {
                mode: 'radio',
                className: 'selectedItemInTable',
                hideSelectColumn: true,
                clickToSelect: true
            },
            newPatient: {
                first_name: '',
                last_name: '',
                notes: ''
            },
            validateNewPatient: {
                first_name: true,
                last_name: true
            },
            addNewPatient: false,
            patientId: this.props.props && this.props.props.match && this.props.props.match ? this.props.props.match.params.patientId : false,
            deletedPatiientId: 0,
            editPatientModal: false,
            editPatiientId: 0,
            isPickup: false,
            isOpenPickupModal: false,
            isHistoryModalOpen: false,
            currentPage: 1,
            filterOptions: this.props.props.history &&  this.props.props.history.location &&  this.props.props.history.location.state && this.props.props.history.location.state.filterData ? this.props.props.history.location.state.filterData : {},
            sortingOptions: {},
            addingBookingInfo: {
                parent_id: null,
                patient_id: 0,
                sending_date: null,
                number_of_units: 0,
                type: '',
                notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
            },
        }
        this.addNewPatient = this.addNewPatient.bind(this);
        this.makeCallRequest = this.makeCallRequest.bind(this);
        this.fullNameFormatter = this.fullNameFormatter.bind(this);
        this.imagesFormatter = this.imagesFormatter.bind(this);
        this.formatAction = this.formatAction.bind(this);
        this.historyFormatter = this.historyFormatter.bind(this);
        this.idFormatter = this.idFormatter.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleFilterDataChange = this.handleFilterDataChange.bind(this);
        this.getAllCases = this.getAllCases.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.getFilteredDataRequest = this.getFilteredDataRequest.bind(this);
        this.childColumnFormatter = this.childColumnFormatter.bind(this);
        this.patientFormatter = this.patientFormatter.bind(this);
        this.toggleSubcaseFormModal = this.toggleSubcaseFormModal.bind(this);
    }

    componentDidMount () {

        document.title = "Case Summary";

        if(this.props.props.history &&  this.props.props.history.location &&  this.props.props.history.location.state && this.props.props.history.location.state.filterData){
            this.setState({filterOptions:this.props.props.history.location.state.filterData})
        }
        this.props.getParentCases();
        const locationState = this.props.props && this.props.props.history.location.state;
        let {currentPage, filterOptions, patientId, sortingOptions} = this.state;
        if(locationState && locationState.patientId ) {
            this.setState({ patientId: locationState.patientId});
            patientId = locationState.patientId;
            locationState.patientId = false;
        }
        this.interval = setInterval(this.makeCallRequest, 7000);
        if(locationState && locationState.pageNumber ) {
            this.setState({ currentPage: locationState.pageNumber});
            currentPage = locationState.pageNumber;
            locationState.pageNumber = 1;
        }
        if(locationState && locationState.filterData ) {
            this.setState({filterOptions: locationState.filterData});
            filterOptions = locationState.filterData;
            locationState.filterData = {};
        }
        this.props.getPatient({patientId, page: currentPage, filterOptions, sortingOptions});
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    makeCallRequest() {
        const {filterOptions, currentPage, patientId, sortingOptions} = this.state;
        this.props.getPatient({
            patientId,
            page: currentPage,
            filterOptions,
            sortingOptions,
        });
    }

    handlePageChange(currentPage) {
        this.setState({currentPage});
        const {filterOptions, patientId, sortingOptions} = this.state;
        this.props.getPatient({patientId, page: currentPage, filterOptions, sortingOptions});
    }

    linkToCasesPage (row) {
        if(row.id === this.state.patientId) {
            this.setState({ patientId: false, selectRowProp: {...this.state.selectRowProp, selected: [] }});
            this.props.getPatient({});
            this.props.history.push('/account/');
        } else {
            this.setState({ patientId: row.id });
            this.props.getPatient({patientId: row.id});
            this.props.history.push('/case-summary/'+row.id);
            this.setState({selectRowProp: {...this.state.selectRowProp, selected: [row.id]}});
        }
        this.setState({
            filterOptions: {},
            sortingOptions: {},
            currentPage: 1,
        });
    }

    linkToPerCasePage (row, e) {
        if(!row.parentId) {
            e.stopPropagation();
        }
        const pageNumber = this.state.currentPage;
        const {patientId, filterOptions,sortingOptions} = this.state;
        this.props.props && this.props.props.history.push({
            pathname: '/case-details/'+row.caseId,
            state: {page: '/account', pageName: 'Cases',sortingOptions, filterData: filterOptions, pageNumber, patientId, tabName: "case_summary"}
        });
    }

    idFormatter (cell, row) {
        return  (
            <div>
                {cell}
            </div>
        )
    }
    patientFormatter (cell) {
        return  <div key={cell} dangerouslySetInnerHTML={{__html: cell}}/>
    }
    imagesFormatter (cell, row) {
        return <div className="photos">
            <button onClick={(event) => this.seePhotos(event,row)}>
                {cell ?
                    <span className="kr kr-images"/>
                    :
                    <span className="kr kr-image"/>
                }
            </button>
            <span>({cell})</span>
        </div>;
    }

    formatAction (cell, row) {
        return (
            <div className="user-cases-icon">
                {(row.status === 'Scheduled' || row.status === 'Rescheduled') && row.pickup == 0 ?
                    <button
                        data-for="schedule-pickup"
                        data-tip="Schedule Pickup"
                        className="pickup__button "
                        onClick={(event) => this.addPickup(event, row, true)}
                    >
                        <span className="kr kr-approve-schedule" />
                        <ReactTooltip place="top" id="schedule-pickup" type="light" effect="float"/>
                    </button>
                    :
                    (row.status === 'Scheduled' || row.status === 'Rescheduled') && row.pickup == 1 ?
                        <button
                            data-for="cancel-pickup"
                            data-tip="Cancel Pickup"
                            className="pickup__button"
                            onClick={(event) => this.addPickup(event, row, false)}
                        >
                            <span className="kr kr-cancel-schedule" />
                            <ReactTooltip place="top" id="cancel-pickup" type="light" effect="float"/>
                    </button> : ''}
            </div>
        );
    }

    addPickup (event, caseDetails, isPickup) {
        event.stopPropagation();
        this.setState({ isPickup });
        if(!this.state.isOpenPickupModal && !isPickup) {
            this.setState({isOpenPickupModal: true, isPickup, caseToPickup: caseDetails});
        } else {
            this.props.addPickup(caseDetails.caseId, isPickup);
        }
    }

    handleClosePickupModal() {
        this.setState({isOpenPickupModal: false});
        if(this.state.isPickup) {
            Notice.addNotification('You can schedule a pickup from Cases menu when the case is ready', 'success');
        } else {
            Notice.addNotification('You can cancel a pickup from Cases menu anytime', 'success');
        }
    }

    fullNameFormatter (row, cell) {
        const patientId = cell.id;
        return (
            <Row>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-10">
                            <p>{ cell.fullName }</p>
                        </div>
                        <div className="col-md-2 text-right">
                            <div className="row">
                                <IconEdit data-tip="Edit" size={20} style={{color: '#56c4c5', cursor: 'pointer'}} onClick={ (event) => this.editPatient(event, patientId) }/>
                                <IconTrash data-tip="Delete" size={20} style={{color: '#f5796d', cursor: 'pointer'}} onClick={ (event) => this.deletePatient(event, patientId) } />
                            </div>
                        </div>
                    </div>
                </div>
            </Row>
        )
    }
    editPatient (event, patientId) {
        if (this.state.editPatientModal) {
            this.props.editPatient({
                ...this.state.editPatientInfo,
                filterOptions: this.state.filterOptions,
                page: this.state.currentPage,
                sortingOptions: this.state.sortingOptions,
            });
        } else {
            const patient = this.getPatientById(patientId);
            this.setState({
                editPatientModal: true,
                editPatiientId: patientId,
                editPatientInfo: patient,
            });
        }
        event.stopPropagation();
    }


    dateFormatter (cell) {
        return (
            <Moment format="DD/MM/YYYY">
                { cell }
            </Moment>
        );
    }

    handleClose = () => {
        this.setState({
            addNewPatient: false,
            deletePatientModal: false,
            validateNewPatient: {
                first_name: true,
                last_name: true,
            },
            isHistoryModalOpen: false,
            addBookingShow: this.state.openBookingFormAfterAddNewPatient,
            printModal: false,
            openBookingFormAfterAddNewPatient: false,
            moreThenAvailableUnitsModal: false,
            editPatientModal: false,
            validationBooking: {
                dentist_id: false,
                patient_id: false,
                sending_date: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false
            },
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                sending_date: null,
                image: [],
            },
            isOpenLeaveModal: false,
            isOpenStartTour: false,
            createSubcaseModal: false
        });
    }

    addNewPatient () {
        this.setState({addNewPatient: true})
    }

    getAllCases () {
        this.props.props.history.push('/account');
        this.setState({patientId: false, filterOptions: {},
            sortingOptions: {},
            currentPage: 1,
            selectRowProp: {...this.state.selectRowProp, selected: []}
            }, () =>  this.props.getPatient({}));
    }

    handelChange (key, value) {
        this.setState(prevState => ({
            newPatient: {
                ...prevState.newPatient,
                [key]: value,
            }
        }))
    }

    handleAddNewPatient () {
        const { newPatient, filterOptions, sortingOptions, currentPage } = this.state;
        const first_name = !!(newPatient.first_name);
        const last_name = !!(newPatient.last_name);
        newPatient.filterOptions = filterOptions;
        newPatient.page = currentPage;
        newPatient.sortingOptions = sortingOptions;
        if (!first_name || !last_name) {
            this.setState({validateNewPatient: {
                first_name: first_name,
                last_name: last_name,
                }
            })
        } else {
            this.props.addPatient(newPatient);
        }
    }
    getPatientById (patientId) {
        let patient = undefined;
        this.patientList.map((item) => {
            if (item.id === patientId) {
                return patient = item;
            } else {
                return false
            }
        });
        return patient;
    }

    handelChangeEdit (key, value) {
        this.setState({
            editPatientInfo: {
                ...this.state.editPatientInfo, [key]: value
            }
        })
    }

    get patientList () {
        return this.props.home.patientList.patients;
    }

    get patientsCasesList () {
        return this.props.home.patientList.events;
    }


    historyFormatter (cell, row) {
        return <div>
            <div className="see-history"  data-for="history" data-tip={!row.numberOfLogs ? "No history" : ''}>
                <button
                    type='button'
                    disabled={!row.numberOfLogs}
                    className="btn btn-link"
                    onClick={() => this.setState({ isHistoryModalOpen: true, selectedCaseToShowHistory: row.id })}
                >
                    <span className="kr kr-history" />
                    <span>See History</span>
                </button>
            </div>
            <ReactTooltip place="top" type="light" id="history" effect="float" />
            <ReactTooltip place="top" type="light" id="info" effect="float" />
        </div>;
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.home.editPatient === false) {
            Notice.addNotification('Your session is expired.', 'error');
            this.setState({editPatientModal: false })
        } else if (nextProps.home.editPatient) {
            Notice.addNotification('Patient is successfully edited.', 'success');
            this.setState({editPatientModal: false })
        } else if (!this.props.home.added && nextProps.home.added === true) {
            Notice.addNotification('Patient is successfully added.', 'success');
            this.setState({addNewPatient: false, newPatient: {first_name: '',last_name: '',notes: ''}, validateNewPatient: {first_name: true,last_name: true}})
        } else if (nextProps.home.editPatient === false) {
            Notice.addNotification('Your session is expired.', 'error');
            this.setState({addNewPatient: false})
        } else if (nextProps.home.pickupScheduled && !this.props.home.pickupScheduled) {
            const message = this.state.isPickup ? SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE : CANCEL_PICKUP_CASE_SUCCESS_MESSAGE;
            Notice.addNotification(message, 'success');
            this.setState({ isOpenPickupModal: false, isPickup: false });
            this.makeCallRequest();
        }
        if (nextProps.caseDetails.getCasesSuccess && this.state.addingBookingInfo.parent_id && !this.state.printModal) {
            this.setState({ isOpenSubcaseForm: true, createSubcaseModal: false });
        }
        if(nextProps.home.addBookingRequest) {
            Notice.addNotification(ADD_CASE_SUCCESS_MESSAGE, 'success');
            const { startOfCalendarView, endOfCalendarView } = this.state;
            this.props.getPatient({ startOfCalendarView, endOfCalendarView });
            this.props.getCase(nextProps.home.addedData);
            this.setState({
                addBookingShow: false,
                moreThenAvailableUnitsModal: false,
                printModal: true,
                modalHeaderText: 'Print Booking',
                modalBodyText: 'Would you like to print the case?',
                addingBookingInfo: {
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: []
                },
                isOpenSubcaseForm: false,
                validationBooking: { patient_id: false, number_of_units: false, type: false, implant: false, sending_date: false, enclosedBox: false }
            });
        }
    }

    seePhotos(event, row) {
        event.stopPropagation();
        const pageNumber = this.state.currentPage;
        const filterOptions = this.state.filterOptions;
        const patientId = this.state.patientId;
        this.props.props && this.props.props.history.push({
            pathname: `/case-details/${row.caseId}`,
            state: {showImages: true, page: '/case-summary', pageName: 'Cases', filterData: filterOptions, pageNumber, patientId}
        })
    }

    handleFilterDataChange (filterOptions) {
        if(!_.isEqual(filterOptions, this.state.filterOptions)) {
            this.setState({filterOptions, currentPage: 1});
        }
    }

    getFilteredDataRequest() {
        const currentPage = 1;
        const {filterOptions, patientId, sortingOptions} = this.state;
        this.props.getPatient({patientId,  page: currentPage, filterOptions, sortingOptions});
        this.setState({currentPage});
    }

    handleSort(column, type) {
        const sortingOptions = {sortBy: column, sortingDirection: type};
        const {filterOptions, currentPage, patientId} = this.state;
        this.props.getPatient({patientId,  page: currentPage, filterOptions, sortingOptions});
        this.setState({sortingOptions});
    }

    childColumnFormatter(cell, row) {
        return <div className="cases-icons">
            <button className="btn btn-link" data-tip="View Case Details" onClick={(e) => this.linkToPerCasePage(row, e)}>
                <span className="kr kr-open" />
                <ReactTooltip place="top" type="light" effect="float" />
            </button>
            {row.parentId ? <div className="subcase_image"><a
                data-tip={`This is a subcase of case N${row.parentId}`}
                data-for="child"
                href={`/case-details/${row.parentId}`}>
                <span className="kr kr-parent"/>
            </a>
                <ReactTooltip id="child" place="right" type="light" effect="float"/>
            </div> : null}
        </div>
    }

    toggleSubcaseFormModal = (item) => {
        if (item) {
            this.props.getCase(item.caseId)
        }
        this.setState({ isOpenSubcaseForm: false, addingBookingInfo: { ...this.state.addingBookingInfo, parent_id: item ? item.caseId : null } });
    }

    toggleCasesDropdown = () => {
        this.setState({
            isOpenCasesDropdown: !this.state.isOpenCasesDropdown,
        })
    }

    render () {
        const header = 'Case summary';
        const desc = 'Case summary & patients list';
        const cases = this.patientsCasesList || [];
        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    openTour={() => this.setState({ isOpenStartTour: true })}
                    openSubCaseModal={() => this.setState({ createSubcaseModal: true }, () => this.props.getParentCases())}
                    isTour={false}
                />
                <div className="view-content dentist__dashboard">
                    <div>
                        <div className="user">
                            <div className="user__block">
                                <div className="user__list">
                                    {
                                        (this.props.home.loadingBookings === true) ?
                                            <Spinner />
                                        :
                                            <PatientsTable
                                                history={this.props.props && this.props.props.history}
                                            />
                                    }
                                </div>
                                <div className="user__cases">
                                    {
                                        (this.props.home.loadingBookings === true || this.props.addingDataLoading) ?
                                            <Spinner />
                                            :
                                            <Fragment>
                                                <div className="tabs">
                                                    <div className={`tabs__item ${this.props.tabName === 'patients' ? 'active_tab' : ''}`} onClick={()=>this.props.changeTab('patients')}>Calendar</div>
                                                    <div className={`tabs__item ${this.props.tabName === 'case_summary' ? 'active_tab' : ''}`} onClick={()=>this.props.changeTab('case_summary')}>Case Summary</div>
                                                </div>
                                                <div className="dashboard-block">
                                                    <Table
                                                        patientId={this.state.patientId}
                                                        totalNumber={this.props.home.patientList.totalNumber}
                                                        columns={[
                                                            {name: '$$', key: 'filter', render: (cell, row) => this.childColumnFormatter(cell, row), src: require('../../../../images/filter.svg')},
                                                            {name: 'Case ID', key: 'id',placeholder: "1234", render: (cell, row) => this.idFormatter(cell, row), isSortable: true, isFilterable: true, filterType: 'number' },
                                                            {name: 'Submission Date', key: 'dateOfSubmission', placeholder: "DD/MM/YYYY", render: cell => this.dateFormatter(cell), isSortable: true, isFilterable: true, filterType: 'date'},
                                                            {name: 'Sending Date', key: 'sendingDate', placeholder: "DD/MM/YYYY", render: cell => this.dateFormatter(cell), isSortable: true, isFilterable: true, filterType: 'date'},
                                                            {name: 'Return Date', key: 'dateOfReturn',placeholder: "DD/MM/YYYY", render: cell => this.dateFormatter(cell), isSortable: true, isFilterable: true, filterType: 'date'},
                                                            {name: 'Units', key: 'numberOfUnits', render: cell => cell, isSortable: true, isFilterable: true, filterType: 'number'},
                                                            {name: 'Patient', key: 'patient', render: cell => this.patientFormatter(cell), isSortable: true, isFilterable: true, filterType: 'text'},
                                                            {name: 'Status', key: 'status', render: arg => arg === 'Onhold' ? 'On hold' : arg, isSortable: true, isFilterable: true, filterType: 'select', options: [{ value: 'Pending', label: 'Pending' }, { value: 'Overdue', label: 'Overdue' }, { value: 'Scheduled', label: 'Scheduled' }, { value: 'Received', label: 'Received' }, { value: 'Ready', label: 'Ready' }, { value: 'Rejected', label: 'Rejected' }, { value: 'Archived', label: 'Archived' },  { value: 'Onhold', label: 'On hold' }]},
                                                            {name: 'Photos', key: 'numberOfImages', render: (cell, row) => this.imagesFormatter(cell, row)},
                                                            {name: 'History', key: 'history', render: (cell, row) => this.historyFormatter(cell, row)},
                                                            {name: 'Actions', key: 'actions', render: (cell, row) => this.formatAction(cell, row)},
                                                        ]}
                                                        columnShow={this.props.home.tableConfigDentist}
                                                        isAdmin={false}
                                                        data={cases.map(item => ({...item, id: item.caseId, patient: item.title}))}
                                                        filterOptions={this.state.filterOptions}
                                                        handleFilterDataChange={this.handleFilterDataChange}
                                                        handlePageChange={this.handlePageChange}
                                                        currentPage={this.state.currentPage}
                                                        isHeaderHidden={false}
                                                        pagination={true}
                                                        getFilteredDataRequest={this.getFilteredDataRequest}
                                                        sortingOptions={this.state.sortingOptions}
                                                        handleSort={this.handleSort}
                                                        className="cases-mobile-table"
                                                    />
                                                </div>
                                            </Fragment>
                                    }
                                </div>
                            {
                                this.state.addNewPatient &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Add New Patient"
                                    modalBody={ <CustomModalBody handelChange={(key, value) => this.handelChange(key, value)} validation={this.state.validateNewPatient} /> }
                                    show={this.state.addNewPatient}
                                    handleClose={this.handleClose}
                                    buttonText="Add"
                                    buttonFunction={() => this.handleAddNewPatient()}
                                />
                            }
                            {
                                this.state.editPatientModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Edit Patient"
                                    modalBody={ <CustomModalBody editPatientInfo={this.state.editPatientInfo} handelChange={(key, value) => this.handelChangeEdit(key, value)} validation={this.state.validateNewPatient} /> }
                                    show={this.state.editPatientModal}
                                    handleClose={this.handleClose}
                                    buttonText="Save"
                                    buttonFunction={(event) => this.editPatient(event, this.state.editPatiientId)}
                                />
                            }
                            {
                                this.state.isOpenPickupModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Cancel Pickup"
                                    modalBody="Are you sure you want to cancel the pickup?"
                                    show={this.state.isOpenPickupModal}
                                    isPickupModal={true}
                                    caseDetails={this.state.caseToPickup}
                                    handleClose={() => this.handleClosePickupModal()}
                                    buttonText="Yes"
                                    buttonFunction={(e) => this.addPickup(e, this.state.caseToPickup, this.state.isPickup)}
                                    isAdmin={false}
                                />
                            }
                            {
                                this.state.isHistoryModalOpen &&
                                <ModalComponent
                                    modalHeaderStyle={this.state.modalHeaderType}
                                    headerTitle={<span className="history__btn">Case History</span>}
                                    historyModal={true}
                                    modalBody={
                                        <History caseId={this.state.selectedCaseToShowHistory}/>
                                    }
                                    show={this.state.isHistoryModalOpen}
                                    handleClose={this.handleClose}
                                />
                            }
                                {
                                    this.state.createSubcaseModal &&
                                    <ModalComponent
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle="Create Subcase"
                                        modalTitle="subcaseModalTitle modalTitle"
                                        infoModal={true}
                                        modalBody={<SubcaseModalBody
                                            toggleCasesDropdown={() => this.toggleCasesDropdown()}
                                            isOpenCasesDropdown={this.state.isOpenCasesDropdown}
                                            toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                            eventList={this.props.home.parentCases}
                                        />}
                                        dialogClassName={"subcase__modal__dialog"}
                                        show={this.state.createSubcaseModal}
                                        handleClose={() => this.handleClose()}
                                    />
                                }
                                {
                                    this.state.isOpenSubcaseForm ?
                                        <SubcaseForm
                                            caseDetails={this.props.home.caseList ? this.props.home.caseList.caseDetails : []}
                                            parent_id={this.state.addingBookingInfo.parent_id}
                                            isAdmin={false}
                                            dashboard={this.props.home}
                                            dashboardData={this.props.home.patientList}
                                            toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                            getData={this.props.getPatient}
                                            isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                            addPatient={this.props.addPatient}
                                            addDentist={this.props.addDentist}
                                            addBooking={this.props.addBooking}
                                            saveDisabled={this.props.home.addingDataLoading}
                                            minDateForSubcase={this.props.caseDetails.caseList.minDateForSubcase}
                                        />
                                        : ''
                                }
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        home: state.home,
        caseDetails: state.caseDetails,
        addingDataLoading: state.home.addingDataLoading,
        adddedBooking: state.home.addBookingRequest,
        isPatientDeleted: state.home.deletePatient,
        validationMessage: state.home.validationMessage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addBooking: (data) => { dispatch(addBooking(data)); },
        addPatient: (data) => { dispatch(addPatient(data)); },
        getPatient: (data) => { dispatch(getPatient(data)); },
        deletePatient: (patientId, data) => { dispatch(deletePatient(patientId, data)); },
        editPatient: (data) => { dispatch(editPatient(data)); },
        addPickup: (caseId, isPickup) => { dispatch(addPickup(caseId, isPickup)); },
        getCaseDetails: (caseId, isPickup) => { dispatch(getCase(caseId, isPickup)); },
        getParentCases: () => { dispatch(getParentCases()); },
        getCase: (caseId) => { dispatch(getCase(caseId)); },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cases);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Cases/index.js